module.exports = __webpack_public_path__ + "img/20_124.b56b8210.png";